import styled from 'styled-components';

const StyledContainer = styled.div`
	width: 160px;
	height: 10px;
	margin: 20px 0 0 15px;
	background: #ffffff;
	opacity: 0.25;
	border-radius: 10px;
	transition: opacity 0.3s ease;
`;

const StyledWrapper = styled.div`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: 0;
	z-index: 10;
	width: 190px;
	height: 50px;
	cursor: pointer;

	&:hover {
		${StyledContainer} {
			opacity: 1;
		}
	}
`;

export { StyledContainer, StyledWrapper };
